// 3rd party imports
import * as React from 'react';
import { Layer } from 'bernie-view';
import { useStores } from 'hooks';
import { DialogRoute, closeDialog } from 'bernie-core';

// uitk
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';

// Shared UI
import { useLocalization } from '@shared-ui/localization-context';
import { LocalizedText } from '@shared-ui/localization-context';

// components
import { analyticsEvent } from '../../util/analytics';
import { observer } from 'mobx-react';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { LocalizedTextWrapping } from 'components/localized-text-wrapping';
import { UitkLink } from 'uitk-react-link';

export const IndustryDefinitionDialog = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function IndustryDefinitionDialog() {
    const { analytics, userAuth, pzStore } = useStores();
    const l10n = useLocalization();

    const dialogId = 'industry-definition';

    const history = useHistory();
    const location = useLocation();

    const onDismiss = () => {
      closeDialog({ history, location, key: dialogId });
      analyticsEvent(
        analytics,
        userAuth,
        pzStore,
        'affhub.industry_definition_dialog.dismissed',
        'Industry Definition Dialog Dismissed',
      );
    };

    const handleClick = () => {
      onDismiss();
    };

    React.useEffect(() => {
      analyticsEvent(
        analytics,
        userAuth,
        pzStore,
        'affhub.industry_definition_dialog.presented',
        'Industry Definition Dialog Presented',
      );
    }, []);

    return (
      <>
        <DialogRoute id={dialogId}>
          <Layer onDismiss={onDismiss} id={dialogId}>
            <UitkDialog returnFocusOnClose={true} className="IndustryDefinitionDialog__container">
              <UitkDialogContent className="IndustryDefinitionDialog__content">
                <UitkLayoutFlex direction="column" space="six">
                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h1" size={3}>
                        <LocalizedText message="industry.dialog.title.industry_definitions" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.info.see_below_the_list_of_industries" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.cashback" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.cashback.membership_programs_where_members" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.coupons_deals" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.coupons.trusted_businesses_that_provide" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.content_sites" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.content.trusted_businesses_who_provide" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.closed_user_group" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.closed.benefits_portals_that_promote" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.financial_services" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.financial.financial_institutions_that_want" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.loyalty_offers" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.loyalty.loyalty_programs_of_businesses" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.meta_sites" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.metasites.travel_search_aggregators" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.offline_travel_agents" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedTextWrapping
                        message="industry.dialog.offline.offer_the_booking_service"
                        fieldName="expedia_taap"
                      >
                        <a href={`https://www.expedia.com/taap-info`} target="_blank">
                          <LocalizedText message="industry.dialog.link_name.expedia_taap" />
                        </a>
                      </LocalizedTextWrapping>
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.online_travel_agents" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.online.offer_the_capability_for_customers" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.travel_suppliers" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.travelsuppliers.loyalty_programs_of_travel_suppliers" />
                    </UitkText>
                  </div>

                  <div>
                    <UitkSpacing margin={{ blockend: 'two' }}>
                      <UitkHeading tag="h2" size={5}>
                        <LocalizedText message="affiliate.industry.sub-affiliate_networks" />
                      </UitkHeading>
                    </UitkSpacing>

                    <UitkText>
                      <LocalizedText message="industry.dialog.subaffiliate.companies_that_provide_ecommerce" />
                    </UitkText>
                  </div>
                </UitkLayoutFlex>
              </UitkDialogContent>

              <UitkDialogFooter
                key="UitkDialogFooter"
                buttonOne={{
                  onClick: handleClick,
                  text: l10n.formatText('common.dialog.close'),
                  type: 'tertiary',
                }}
              />
            </UitkDialog>
          </Layer>
        </DialogRoute>
      </>
    );
  },
);
